import { JSX } from 'react'

import { IconProps } from '../../icon'

const Delete: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M17.7949 10.4615H30.9231C31.5959 10.4615 32.1538 9.90359 32.1538 9.23077C32.1538 8.55795 31.5959 8 30.9231 8H17.7949C17.1221 8 16.5641 8.55795 16.5641 9.23077C16.5641 9.90359 17.1221 10.4615 17.7949 10.4615Z'
      fill='black'
    />
    <path
      d='M37.4872 12.9231H11.2308C10.5579 12.9231 10 13.481 10 14.1538C10 14.8267 10.5579 15.3846 11.2308 15.3846H11.7231L12.8718 32.7303C13.1508 36.8164 16.5641 40 20.6503 40H28.0677C32.1538 40 35.5672 36.8 35.8462 32.7303L36.9949 15.3846H37.4872C38.16 15.3846 38.7179 14.8267 38.7179 14.1538C38.7179 13.481 38.16 12.9231 37.4872 12.9231ZM33.3846 32.5662C33.2041 35.3559 30.8574 37.5385 28.0677 37.5385H20.6503C17.8441 37.5385 15.5138 35.3559 15.3333 32.5662L14.1846 15.3846H34.5333L33.3846 32.5662Z'
      fill='black'
    />
    <path
      d='M24.359 33.4359C25.0318 33.4359 25.5897 32.878 25.5897 32.2051V20.718C25.5897 20.0451 25.0318 19.4872 24.359 19.4872C23.6862 19.4872 23.1282 20.0451 23.1282 20.718V32.2051C23.1282 32.878 23.6862 33.4359 24.359 33.4359Z'
      fill='black'
    />
    <path
      d='M29.2821 33.4359C29.9549 33.4359 30.5128 32.878 30.5128 32.2051V20.718C30.5128 20.0451 29.9549 19.4872 29.2821 19.4872C28.6092 19.4872 28.0513 20.0451 28.0513 20.718V32.2051C28.0513 32.878 28.6092 33.4359 29.2821 33.4359Z'
      fill='black'
    />
    <path
      d='M19.4359 33.4359C20.1087 33.4359 20.6667 32.878 20.6667 32.2051V20.718C20.6667 20.0451 20.1087 19.4872 19.4359 19.4872C18.7631 19.4872 18.2051 20.0451 18.2051 20.718V32.2051C18.2051 32.878 18.7631 33.4359 19.4359 33.4359Z'
      fill='black'
    />
  </svg>
)

export default Delete
